function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "9.795%",
  y1: "26.65%",
  x2: "99.779%",
  y2: "43.394%",
  id: "temple-study_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D61772",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A0398E",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 51V29m48 0v22m-16 0V29M22 51V29m38 22v8H0v-8h60zM30 0l30 16v7H0v-7L30 0zm0 9a4 4 0 100 8 4 4 0 000-8z",
  transform: "translate(1 2)",
  stroke: "url(#temple-study_svg__a)",
  strokeWidth: 2,
  fill: "none",
  strokeLinecap: "square"
});

function SvgTempleStudy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 62"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MiA2MiI+PGRlZnM+PGxpbmVhckdyYWRpZW50IHgxPSI5Ljc5NSUiIHkxPSIyNi42NSUiIHgyPSI5OS43NzklIiB5Mj0iNDMuMzk0JSIgaWQ9ImEiPjxzdG9wIHN0b3AtY29sb3I9IiNENjE3NzIiIG9mZnNldD0iMCUiLz48c3RvcCBzdG9wLWNvbG9yPSIjQTAzOThFIiBvZmZzZXQ9IjEwMCUiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48cGF0aCBkPSJNNiA1MVYyOW00OCAwdjIybS0xNiAwVjI5TTIyIDUxVjI5bTM4IDIydjhIMHYtOGg2MHpNMzAgMGwzMCAxNnY3SDB2LTdMMzAgMHptMCA5YTQgNCAwIDEwMCA4IDQgNCAwIDAwMC04eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAyKSIgc3Ryb2tlPSJ1cmwoI2EpIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPjwvc3ZnPg==";
export { SvgTempleStudy as ReactComponent };